import findById from "./findById";
import removeEmptyFields from "./removeEmptyFields";
import Translate from "./translate";

const { t } = new Translate("AssetNavigator");

const getName = (arr, id) => !!findById(arr, id) && findById(arr, id).name;

const printFilter = (filter = {}, regions = [], portfolios = []) => {
  if (filter.isFiltering) {
    const filterText = [];
    const period = filter.budget.period ? ` / ${t(`units.${filter.budget.period}`)}` : "";
    const unit = t(`units.${filter.size.unit}`);
    const currency = t(`units.${filter.budget.currency}`);
    Object.keys(removeEmptyFields(filter)).forEach((k) => {
      switch (k) {
        case "category":
          filterText.push(`${t("category")}: ${t(`spaceCategories.${filter.category}`)}`);
          break;
        case "budget":
          if (filter.budget.from && filter.budget.to) {
            filterText.push(`${filter.budget.from} - ${filter.budget.to} ${currency}${period}`);
          } else if (filter.budget.to) {
            filterText.push(`Max: ${filter.budget.to} ${currency}${period}`);
          } else if (filter.budget.from) {
            filterText.push(`Min: ${filter.budget.from} ${currency}${period}`);
          }
          break;
        case "size":
          if (filter.size.from && filter.size.to) {
            filterText.push(`${filter.size.from} - ${filter.size.to} ${unit}`);
          } else if (filter.size.to) {
            filterText.push(`Max: ${filter.size.to} ${unit}`);
          } else if (filter.size.from) {
            filterText.push(`Min: ${filter.size.from} ${unit}`);
          }
          break;
        case "regionIDs":
          if (!filter.regionIDs.length || !regions.length) break;
          filterText.push(filter.regionIDs.map((id) => getName(regions, id)).join(", "));
          break;
        case "portfolioIDs":
          if (!filter.portfolioIDs.length || !portfolios.length) break;
          filterText.push(filter.portfolioIDs.map((id) => getName(portfolios, id)).join(", "));
          break;
        case "status":
          if (filter.status === "public") break;
          filterText.push(`${t("status")}: ${t(`spaceStatuses.${filter.status}`)}`);
          break;
        case "keywords":
          filterText.push(filter[k]);
          break;
        default:
          break;
      }
    });

    return filterText.join(" | ");
  }

  return null;
};

export default printFilter;
